const formatter = new Intl.NumberFormat("de-DE", {
	maximumFractionDigits: 2
});

export default (value : number) : string => formatter.format(value);
